import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
// import styles from "src/bulk-order.module.scss";
import { initFeedSocket as solaceInitFeedSocket, onFocusChange as solaceOnFocusChange, } from "src/utils/solacesocketwrapper";
import { initFeedSocket, onFocusChange } from "src/utils/websocketwrapper";
import { onWindowBlur, onWindowBlurTime, onWindowFocus, } from "src/redux/reducers/app";
import { initializeFireBaseAppAndRemoteConfig } from "src/utils/custom-remote-config";
import { initDashboardApiWorker } from "./apis/dashboard.controller";
import usePageVisibility from "./hooks/usePageVisibility";
import { reSubscribeDepthSocket, unSubscribeAllDepthData, } from "./utils/depth-web-socket";
import { setPreferenceFirebase } from "./utils/methods";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "./utils/session-storage";
import { updateSessionDataInSocket } from "./utils/solacesocketwrapper";
// import { initFeedSocket, onFocusChange } from "./utils/websocketwrapper";
const { REACT_APP_ENV } = process.env;
const AppWapper = () => {
    const [clientCode, setClientCode] = useState(getDataFromSession(SESSION_KEYS.CLIENT_CODE)
    // getDataFromSession(SESSION_KEYS.CLIENT_CODE)
    );
    const isSolaceEnabled = useAppSelector((state) => state.commonReducer.isSolaceEnabled);
    const dispatch = useAppDispatch();
    const [isWindowVisible, setIsWindowVisible] = useState(true);
    const [windowChangedTime, setWindowChangedTime] = useState(0);
    const setWindowVisibleCallback = (newValue) => {
        setIsWindowVisible(newValue);
    };
    const isWindowVisibleLocal = usePageVisibility({
        setIsWindowVisible: setWindowVisibleCallback,
    });
    const intervalForPreference = useRef();
    const isWindowFocused = useAppSelector((state) => state.app.isWindowFocused);
    const interval = useRef();
    // set preference firebase calling
    useEffect(() => {
        if (isWindowFocused) {
            // console.log(
            //   "This is tribute Windowfocus event",
            //   new Date().toISOString()
            // );
            interval.current = setInterval(() => {
                if (getDataFromSession(SESSION_KEYS.PREFERENCE_CHANGED) === "true") {
                    setPreferenceFirebase();
                }
            }, 15000);
        }
        else {
            // console.log("This is tribute lost focus event", new Date().toISOString());
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = undefined;
            }
        }
        return () => {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = undefined;
            }
        };
    }, [isWindowFocused]);
    useEffect(() => {
        if (isSolaceEnabled && isWindowFocused) {
            updateSessionDataInSocket();
        }
    }, [isSolaceEnabled, isWindowFocused]);
    useEffect(() => {
        setDataInSession(SESSION_KEYS.HOST_NAME, window.location.hostname);
        if (REACT_APP_ENV == "production" || REACT_APP_ENV == "staging") {
            //initLoggly();
            initializeFireBaseAppAndRemoteConfig();
        }
        if (REACT_APP_ENV == "development") {
            initializeFireBaseAppAndRemoteConfig();
        }
        initDashboardApiWorker();
        if (isWindowVisible) {
            //TODO commented as not working
            // setInterval(setPreferenceFirebase, 15000);
            const windowComebackTime = Date.now();
            dispatch(onWindowFocus());
            dispatch(onWindowBlurTime(windowComebackTime - windowChangedTime));
            initFeedSocket();
            if (isSolaceEnabled) {
                solaceInitFeedSocket();
            }
            if (clientCode) {
                if (REACT_APP_ENV === "development") {
                    // const jwtValue = getDataFromSession(SESSION_KEYS.JWTTOKEN);
                    // const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
                    // const wsUrl = `wss://ttavatar.5paisa.in/TTWebSocketVendor/api/chat?Value1=${jwtValue}|${clientCode}`;
                    // initWebSocket(wsUrl, true);
                    //reSubscribeDepthSocket(clientCode);
                }
                else {
                    // initWebSocket(wsUrl, true);
                    onFocusChange(isWindowVisible);
                    if (isSolaceEnabled) {
                        solaceOnFocusChange(isWindowVisible);
                    }
                    // reSubscribeSocket(clientCode);
                    reSubscribeDepthSocket(clientCode);
                }
            }
        }
        else {
            setWindowChangedTime(Date.now());
            dispatch(onWindowBlur());
            onFocusChange(isWindowVisible);
            if (isSolaceEnabled) {
                solaceOnFocusChange(isWindowVisible);
            }
            // unSubscribeAllData();
            if (REACT_APP_ENV !== "development") {
                unSubscribeAllDepthData();
            }
            if (intervalForPreference.current) {
                clearInterval(intervalForPreference.current);
                intervalForPreference.current = undefined;
            }
        }
        return () => {
            if (intervalForPreference.current) {
                clearInterval(intervalForPreference.current);
                intervalForPreference.current = undefined;
            }
        };
    }, [isWindowVisible, clientCode]);
    return _jsx(_Fragment, {});
};
export default AppWapper;
